import { Column, Row, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface IReadOnlyFieldProps {
  label: string;
  value: string;
  suffix?: string;
  testId?: string;
}

export const ReadOnlyField = ({ label, value, suffix, testId }: IReadOnlyFieldProps) => (
  <Column data-testid={testId} gap={8}>
    <Row alignItems="center" gap={6}>
      <Text bold fontSize={18} color="neutral_600">
        {label}
      </Text>
      {suffix && <Text color="neutral_500">{suffix}</Text>}
    </Row>
    <Row
      height={40}
      borderRadius={10}
      backgroundColor={Colors.neutral_50}
      alignItems="center"
      paddingHorizontal={14}
      style={{
        boxShadow: 'inset 0px 2px 4px rgba(0,0,0,0.25)',
      }}
    >
      <Text fontSize={16} color={'neutral_400'} flex={1}>
        {value}
      </Text>
    </Row>
  </Column>
);
